var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lidaCard"},[_c('div',{staticClass:"tc mb-4"},[_c('h3',[_vm._v(_vm._s(_vm.$route.meta.title))])]),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }